import { render, staticRenderFns } from "./InvitationsDetailTable.vue?vue&type=template&id=1b184b2e&scoped=true"
import script from "./InvitationsDetailTable.vue?vue&type=script&lang=js"
export * from "./InvitationsDetailTable.vue?vue&type=script&lang=js"
import style0 from "./InvitationsDetailTable.vue?vue&type=style&index=0&id=1b184b2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b184b2e",
  null
  
)

export default component.exports